import React from 'react';

import * as S from 'components/modules/Insurance/Insurance.styles';

import { useIssuerInputPresenter } from './IssuerInput.presenter';

export const IssuerInput = ({ name, onChange, type, ...rest }) => {
  const presenter = useIssuerInputPresenter({ name, onChange, type });

  return <S.DaDataUiKit {...rest} name={name} type="fms_unit" onChange={presenter.onChange} />;
};
